import React from 'react';
import {
  BuildingOffice2Icon,
  Cog6ToothIcon,
  UsersIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';
import Select from '../ui/Select';

function PlatformContextBar({
  companies = [],
  selectedCompanyId = null,
  onCompanyChange,
  onViewCompany,
  onConfigureCompany,
  onViewUsers,
}) {
  const { t } = useLanguage();
  const pa = t.platformAdmin;
  const selectedCompany = companies.find((company) => company.id === selectedCompanyId) || null;

  return (
    <div className="rounded-2xl border border-orange-200/50 bg-gradient-to-r from-orange-50/80 to-amber-50/50 p-4 shadow-soft   ">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:items-center">
          <div className="inline-flex items-center gap-2 text-sm font-semibold text-orange-800 ">
            <BuildingOffice2Icon className="h-4 w-4" />
            {pa.contextLabel}
          </div>
          <div className="flex min-w-0 flex-1 items-center gap-2">
            <Select
              value={selectedCompanyId ? String(selectedCompanyId) : 'all'}
              onChange={(event) => {
                const value = event.target.value;
                onCompanyChange?.(value === 'all' ? null : Number(value));
              }}
              className="max-w-sm flex-1"
            >
              <option value="all">{pa.allCompaniesContext}</option>
              {companies.map((company) => (
                <option key={company.id} value={String(company.id)}>{company.name}</option>
              ))}
            </Select>
            {selectedCompanyId ? (
              <button
                type="button"
                onClick={() => onCompanyChange?.(null)}
                className="inline-flex items-center gap-1 rounded-lg px-2 py-1.5 text-xs font-medium text-secondary-600 transition hover:bg-white/70  "
              >
                <XMarkIcon className="h-3.5 w-3.5" />
                {pa.clearContext}
              </button>
            ) : null}
          </div>
        </div>

        {selectedCompany ? (
          <div className="flex flex-wrap items-center gap-2 text-xs text-secondary-600 ">
            <span>{selectedCompany.stats?.clients || 0} {pa.clientsShort}</span>
            <span>·</span>
            <span>{selectedCompany.stats?.vendors || 0} {pa.vendorsShort}</span>
            <span>·</span>
            <span>{selectedCompany.stats?.referrals || 0} {pa.referralsShort}</span>
            <span>·</span>
            <span>${(selectedCompany.stats?.revenue || 0).toLocaleString()}</span>
          </div>
        ) : (
          <p className="text-xs text-secondary-500 ">{pa.allCompaniesContextHint}</p>
        )}

        <div className="flex flex-wrap gap-2">
          {selectedCompany ? (
            <>
              <button
                type="button"
                onClick={() => onViewCompany?.(selectedCompany.id)}
                className="rounded-lg border border-secondary-200 bg-white px-3 py-1.5 text-xs font-semibold text-secondary-700 transition hover:border-orange-200   "
              >
                {pa.viewCompanyDetail}
              </button>
              <button
                type="button"
                onClick={() => onViewUsers?.(selectedCompany.id)}
                className="inline-flex items-center gap-1 rounded-lg border border-secondary-200 bg-white px-3 py-1.5 text-xs font-semibold text-secondary-700 transition hover:border-orange-200   "
              >
                <UsersIcon className="h-3.5 w-3.5" />
                {pa.viewCompanyUsers}
              </button>
              <button
                type="button"
                onClick={() => onConfigureCompany?.(selectedCompany.id)}
                className="inline-flex items-center gap-1 rounded-lg bg-orange-500 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-orange-600"
              >
                <Cog6ToothIcon className="h-3.5 w-3.5" />
                {pa.configure}
              </button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default PlatformContextBar;
